import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isLegacyRuPath, localizedPath, parseLocalePath } from "@/locale/routes";

/** Старые `/ru/*` → канонические безпрефиксные URL (ru master на `/`). */
export function LegacyRuRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLegacyRuPath(pathname)) return;
    const { basePath } = parseLocalePath(pathname);
    navigate(`${localizedPath(basePath, "ru")}${search}${hash}`, { replace: true });
  }, [pathname, search, hash, navigate]);

  return null;
}
